export default "__VITE_ASSET__05b53130__"